"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _slice = require("@lce/slice");

var _SuperLink = _interopRequireDefault(require("../SuperLink"));

var _Social = _interopRequireDefault(require("./Social"));

var _AppBadges = _interopRequireDefault(require("./AppBadges"));

var Styled = _interopRequireWildcard(require("./Footer.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable react/forbid-component-props */

/* eslint-disable max-lines-per-function */


var Footer = function Footer(_a) {
  var _b = _a.enableAppBadges,
      enableAppBadges = _b === void 0 ? true : _b,
      footerLinks = _a.footerLinks,
      SocialProps = _a.SocialProps,
      AppBadgesProps = _a.AppBadgesProps,
      _c = _a.languageSwitch,
      language = _c.language,
      path = _c.path,
      children = _a.children;
  return _react["default"].createElement(Styled.Footer, {
    px: [5, 8],
    py: 5,
    role: "contentinfo"
  }, _react["default"].createElement(Styled.Divider, null), _react["default"].createElement(_slice.Flex, {
    alignItems: "center",
    flexDirection: ['column', 'row'],
    width: 1
  }, _react["default"].createElement(_slice.Flex, {
    flex: [0, 1],
    justifyContent: enableAppBadges && AppBadgesProps ? 'auto' : 'center',
    mb: [3, 0],
    mr: [0, 5],
    width: [1, 1 / 2]
  }, _react["default"].createElement(_Social["default"], (0, _tslib.__assign)({}, SocialProps))), enableAppBadges && AppBadgesProps && _react["default"].createElement(_slice.Flex, {
    justifyContent: ['flex-start', 'flex-end'],
    width: [1]
  }, _react["default"].createElement(_AppBadges["default"], (0, _tslib.__assign)({}, AppBadgesProps)))), _react["default"].createElement(Styled.Divider, null), _react["default"].createElement(Styled.FooterContent, null, _react["default"].createElement(_slice.Flex, {
    flex: "1 1 auto",
    flexWrap: "wrap",
    justifyContent: "space-around",
    mb: 3
  }, _react["default"].createElement(_slice.Flex, {
    flex: "0.5 1 auto",
    flexDirection: ['column', 'row'],
    justifyContent: "space-between",
    mb: 3
  }, (0, _map2["default"])(footerLinks, function (_a, index) {
    var label = _a.label,
        url = _a.url,
        classSelector = _a.classSelector;
    return _react["default"].createElement(_SuperLink["default"], {
      classSelector: classSelector,
      "data-testid": "footer__" + label.replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s/g, '-'),
      href: url,
      key: index,
      title: label
    }, label);
  }), path && language && _react["default"].createElement(_SuperLink["default"], {
    "data-testid": "footer__language__link",
    href: path,
    localize: false
  }, language))), _react["default"].createElement(Styled.FooterCopyright, null, children)));
};

var _default = Footer;
exports["default"] = _default;